import { Text } from '@chakra-ui/react'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'

import { IBodyCell } from '../columnSections'
import { OfferCellWrapper } from './OfferCellWrapper'
import { TinySelect } from './TinySelect'
import { OfferPackage } from 'BrokerTsLib/src/dtos'
import { useSelections } from '../../../../hooks'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { useSetOfferPaymentFrequency } from '../../../../hooks/useOffer'
import { useGetOffersContext } from '../../../../context/useGetOffersContext'
import { useState } from 'react'

const paymentFrequencyOptions = [
  { value: 'monthly', label: 'Měsíční' },
  { value: 'quarterly', label: 'Čtvrtletní' },
  { value: 'semi-annually', label: 'Půlroční' },
  { value: 'annually', label: 'Roční' },
]

export interface IOfferCellPaymentProps extends Omit<IBodyCell, 'value'> {
  value: number,
  offer: OfferPackage
  isDisabled?: boolean
}

export type OfferCellPaymentProps = {
  offerId: number
  isDisabled?: boolean
}


export const OfferCellPayment = ({ offerId, isDisabled }: OfferCellPaymentProps) => {
  const { recalculateOffers: recalculate, offers: o } = useGetOffersContext()
  const offers = o as OfferPackage[]
  const { mutateAsync: updatePf } = useSetOfferPaymentFrequency()

  const offer = offers!.find(x => x.offerId == offerId)

  const { data: pfData } = useSelections(SelectionType.FrekvencePlatby)
  const pf = pfData?.data ?? []

  // aby se zmena projevila na UI hned a ne az po rekalkulaci
  const [paymentFrequencyId, setPaymentFrequencyId] = useState(offer?.paymentFrequencyId)

  const handleEdit = (id: number) => {
    setPaymentFrequencyId(id)
    updatePf({
      offerId: offerId,
      paymentFrequency: id
    }).then(() => {
      recalculate([offerId], true).then((recOffers) => {
        // nektere pojistovny nepodporuji vsechny frekvence plateb
        // je treba upravit nastavenou frekvenci nabidky po rekalkulaci
        if (!recOffers?.data) return
        const recOffer = recOffers.data.find(x => x.offerId == offerId)
        if (recOffer?.paymentFrequencyId) {
          setPaymentFrequencyId(recOffer.paymentFrequencyId)
        }
      })
    })
  }

  return (
    <OfferCellWrapper sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
      <TinySelect
        isDisabled={isDisabled}
        onChange={(e) => {
          handleEdit(parseInt(e.target.value))
        }}
        value={paymentFrequencyId?.toString() ?? ''}
      >
        {pf.map(x => { return { id: x.id, value: x.description ?? x.name ?? '' } }).map((option) => {
          if (!option.value || !option.id) return null

          return (
            <option key={option.value} value={option.id.toString()}>
              {option.value}
            </option>
          )
        })}
      </TinySelect>

      <Text fontSize='sm'>{priceFormat(offer?.priceFrequency)}</Text>
    </OfferCellWrapper >
  )
}
